import { ITransport } from "./ITransport";

export class transport_api {

    public static calc_koszty:string = "/api/transport/calc_koszty"
    public static get_lista_kodow_pocztowych:string = "/api/transport/get_lista_kodow_pocztowych"
    public static find_by_id:string = "/api/transport/find_by_id"
    public static update:string = "/api/transport/update"

}

export interface ITransportSvc {

    calc_koszty(transport:ITransport): Promise<ITransport|undefined>
    get_lista_kodow_pocztowych(obj:any):Promise<string[]|undefined>
    find_by_id(_id: any): Promise<ITransport | undefined> 
    update(problem:ITransport): Promise<ITransport | undefined> 

}